export default function MarkdownItTable(md) {
  md.renderer.rules.table_open = function () {
    return '<table class="custom-table">\n'
  }
  md.renderer.rules.table_close = function () {
    return '</table>\n'
  }
  md.renderer.rules.thead_open = function () {
    return '<thead class="custom-thead">\n'
  }
  md.renderer.rules.thead_close = function () {
    return '</thead>\n'
  }
  md.renderer.rules.tbody_open = function () {
    return '<tbody class="custom-tbody">\n'
  }
  md.renderer.rules.tbody_close = function () {
    return '</tbody>\n'
  }
  md.renderer.rules.tr_open = function () {
    return '<tr class="custom-tr">\n'
  }
  md.renderer.rules.tr_close = function () {
    return '</tr>\n'
  }
  md.renderer.rules.th_open = function () {
    return '<th class="custom-th">\n'
  }
  md.renderer.rules.th_close = function () {
    return '</th>\n'
  }
  md.renderer.rules.td_open = function () {
    return '<td class="custom-td">\n'
  }
  md.renderer.rules.td_close = function () {
    return '</td>\n'
  }
}
